export function keys<T extends { [key: string]: any }>(obj: T): (keyof T)[] {
    return Object.keys(obj);
}
